module.exports = __webpack_public_path__ + "static/media/17_1.5db64ba4.jpg";